import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useConvertTex() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function convertTex(data) {
    return privateFetch.post(`/v1/admin/utils/latex/html`, data).then((res) => res.data);
  }

  return useMutation(convertTex, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('topic-details');
    },
  });
}

export default useConvertTex;
